import classNames from "classnames";
import Link from "next/link";
import * as React from "react";
import Slider from "react-slick";
import { NextArrow } from "@components/HorizontalNewsList/NextArrow";
import { PrevArrow } from "@components/HorizontalNewsList/PrevArrow";
import { NewsCard } from "@components/NewsCard";
import type { NewsCard_NewsArticleListItemFragment } from "@components/NewsCard/__generated__/fragments";
import styles from "./index.module.css";
import type { Settings } from "react-slick";

type Props = {
  newsArticles: Array<NewsCard_NewsArticleListItemFragment>;
  hasMoreButton?: boolean;
  moreNewsLinkPath?: string;
  onClickNews?: (newsId: number) => void;
  onClickMore?: () => void;
};

export const HorizontalNewsList: React.FC<Props> = ({
  newsArticles,
  hasMoreButton = false,
  moreNewsLinkPath = "",
  onClickNews,
  onClickMore,
}) => {
  const SlideSetting: Settings = {
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    swipe: false,
    swipeToSlide: false,
    variableWidth: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 903,
        settings: {
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="md:none">
        <div className={styles.list}>
          {newsArticles.map((news) => (
            <NewsCard
              newsArticle={news}
              landscapeSmall
              key={news.id}
              onClick={() => onClickNews?.(news.id)}
            />
          ))}

          {hasMoreButton && (
            <div className={styles.moreCard} onClick={() => onClickMore?.()}>
              <Link href={moreNewsLinkPath} className={styles.moreButton}>
                <img
                  className={styles.moreButtonIcon}
                  src="/img/icon_search.svg"
                  alt=""
                />
                <span>もっと見る</span>
              </Link>
            </div>
          )}
        </div>
      </div>
      <div className={classNames("none md:block", styles.slider)}>
        <Slider {...SlideSetting}>
          {newsArticles.map((news) => (
            <NewsCard
              newsArticle={news}
              landscapeSmall
              key={news.id}
              onClick={() => onClickNews?.(news.id)}
            />
          ))}

          {hasMoreButton && (
            <div className={styles.moreCard} onClick={() => onClickMore?.()}>
              <Link href={moreNewsLinkPath} className={styles.moreButton}>
                <img
                  className={styles.moreButtonIcon}
                  src="/img/icon_search.svg"
                  alt=""
                />
                <span>もっと見る</span>
              </Link>
            </div>
          )}
        </Slider>
      </div>
    </>
  );
};
